var _defs, _clipPath, _rect, _defs2, _clipPath2, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AMPlogoRGB",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 114.647",
    enableBackground: "new 0 0 288 114.647",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M246.439,0c17.078,6.349,18.487,26.451,18.487,36.588v39.05L288,93.81v-61.53 C288,14.842,279.007,0,262.061,0H246.439z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -161.1987,
    y1: 453.6123,
    x2: -159.645,
    y2: 453.6123,
    gradientTransform: "matrix(0 -60.3863 -60.3863 0 27659.2285 -9640.3896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8CD27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD600"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 246.439,
    clipPath: "url(#SVGID_2_)",
    fill: "url(#SVGID_3_)",
    width: 41.561,
    height: 93.81
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M223.367,0c17.079,6.349,18.489,26.451,18.489,36.588V93.81l23.072-18.171l-0.002-39.05 c0-10.138-1.409-30.24-18.487-36.588H223.367z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -161.1987,
    y1: 453.748,
    x2: -159.645,
    y2: 453.748,
    gradientTransform: "matrix(0 -60.3863 -60.3863 0 27644.3535 -9640.3896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1CA22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A9B9"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223.367,
    clipPath: "url(#SVGID_5_)",
    fill: "url(#SVGID_6_)",
    width: 41.562,
    height: 93.81
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#686869",
    d: "M128.154,31.295c-8.748,0-16.193,4.499-19.723,10.721c-3.531-7.026-9.848-10.721-18.132-10.721 c-7.012,0-12.849,2.891-16.555,7.242v-3.754c0-1.287-1.044-2.331-2.33-2.331h-5.759c-1.288,0-2.33,1.043-2.33,2.331v55.54 c0,1.287,1.042,2.329,2.33,2.329h5.759c1.286,0,2.33-1.042,2.33-2.329V57.457c0-13.021,7.208-17.133,13.544-17.133 c6.55,0,13.891,3.426,13.891,17.554v32.445c0,1.287,1.044,2.329,2.33,2.329h5.759c1.287,0,2.33-1.042,2.33-2.329V57.574 c0-0.043-0.003-0.079-0.003-0.122l0.003,0.004c0-13.021,7.21-17.133,13.547-17.133c6.547,0,13.889,3.426,13.889,17.554v32.445 c0,1.287,1.043,2.329,2.331,2.329h5.758c1.287,0,2.331-1.042,2.331-2.329V57.574C149.454,40.51,141.254,31.295,128.154,31.295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686869",
    d: "M190.898,31.294c-8.78,0-14.52,3.187-18.87,8.56v-5.073c0-1.286-1.043-2.33-2.329-2.33h-5.759 c-1.286,0-2.33,1.043-2.33,2.33v77.536c0,1.285,1.044,2.33,2.33,2.33h5.759c1.286,0,2.329-1.045,2.329-2.33V85.249 c4.351,5.374,10.09,8.558,18.87,8.558c18.131,0,24.775-13.193,24.775-31.256C215.674,44.489,209.029,31.294,190.898,31.294  M188.701,84.779c-10.282,0-16.673-6.701-16.673-21.652v-1.154c0-14.948,6.391-21.65,16.673-21.65 c12.534,0,16.437,9.689,16.437,22.228C205.138,75.091,201.235,84.779,188.701,84.779"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686869",
    d: "M26.975,31.295c-10.794,0-20.68,4.954-23.116,14.511c-0.383,1.498,0.703,2.969,2.247,2.969h5.071 c0.893,0,1.699-0.513,2.091-1.315c1.949-3.988,5.645-7.832,13.591-7.832c13.209,0,13.89,7.432,13.89,15.263l-17.48,2.452 C13.666,58.69,0,63.561,0,76.329C0,86,9.519,93.81,20.955,93.81s17.269-4.947,19.795-8.744v5.257c0,1.287,1.043,2.329,2.33,2.329 h5.76c1.287,0,2.33-1.042,2.33-2.329V52.364C51.17,37.433,41.132,31.295,26.975,31.295 M40.75,65.907 c0,5.953-2.163,19.452-17.48,19.452c-7.413,0-13.082-3.642-13.082-9.841c0-5.519,5.794-9.394,17.023-10.969 c11.229-1.574,13.539-1.898,13.539-1.898V65.907z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmpLogo);
export default __webpack_public_path__ + "static/media/amp-logo.7bf0dd99f11277acec72b9e90d3c1416.svg";
export { ForwardRef as ReactComponent };